import { Page } from '@inertiajs/inertia'
import { InertiaLink, usePage } from '@inertiajs/inertia-react'
import usePageProps from 'app/components/hooks/usePageProps'
import Icon from 'app/components/Icon'
import Img from 'app/components/Img'
import React, { useEffect, useRef, useState } from 'react'
import route from 'ziggy-js'

interface Props {
}

function MenuItem({ href, activeName, name, icon, can }: { href: string, activeName: string, name: string, icon: string, can?: string }) {

    const { user } = usePageProps<{ user: { can: Record<string, boolean> } }>();
    console.log(route()?.current()?.startsWith(activeName), route()?.current())
    return (

        (!can || user.can?.[can]) ?
            <InertiaLink href={href} className="flex min-w-max">
                <div id={`link${icon}`} className={`flex group relative p-13px justify-center -mr-1px border-r border-brown-light hover:text-brown-dark hover:border-brown-dark   items-center ${route()?.current()?.startsWith(activeName) && " text-brown-light"} `}>
                    <Icon className="h-30px" name={icon} />
                    <div className={(`item group-hover:opacity-100 pointer-events-none absolute text-16 -mr-20px -mt-6px rounded-sm bg-black top-0 p-12px z-99999 right-0 text-white transform translate-x-full opacity-0`)}>
                        <div className="whitespace-nowrap">{name}</div>
                        <div className="absolute top-0 left-0 rounded-sm -ml-5px mt-20px w-12px h-12px bg-black transform rotate-45"></div>
                    </div>
                </div>

            </InertiaLink>
            : null
    )
}

const links = [
    { href: route('admin.index'), name: "Menu", icon: "fork", activeName: "menu", },
    { href: route('blocked_date.index'), name: "Blocked dates", icon: "calendar", activeName: "blocked_date", },
    { href: route('reservations.index'), name: "Rezervace", icon: "info", activeName: "reservations", },
    { href: route('catering.index'), name: "Catering", icon: "info", activeName: "catering", },


    // { href: route('herbal.index'), name: "Herbár", icon: "herbal", activeName: "herbal", can: "manage uncomplete"  },
    // { href: route('shrooms.index'), name: "Houbář", icon: "shrooms", activeName: "shrooms", can: "manage uncomplete"  },
]

function SideMenu(props: Props) {
    const { } = props
    const { user } = usePageProps<{ user: { can: Record<string, boolean> } }>();



    return (
        <div className="bg-white border-r border-E1E0E0 h-auto  pb-85px min-h-screen min-w-max">

            <div className='flex flex-col justify-center h-full w-full items-center'>
                {
                    links.map(l => <MenuItem {...l} />)
                }
            </div>
        </div>
    )
}

export default SideMenu
